import { render, staticRenderFns } from "./bar_x.html?vue&type=template&id=475b8a9a&scoped=true&external"
import script from "./bar_xyChart.vue?vue&type=script&lang=js"
export * from "./bar_xyChart.vue?vue&type=script&lang=js"
import style0 from "./bar_xyChart.vue?vue&type=style&index=0&id=475b8a9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b8a9a",
  null
  
)

export default component.exports